
class AAFData {

    get(key) {
        return this[key];
    }

    set(key, value){
        this[key] = value;
    }

}

export default new AAFData();


// WEBPACK FOOTER //
// ./src/utils/AAFData.js